export default "__VITE_ASSET__0a6f61d6__"